export const DEFAULT_ERR_MSG =
    'Something went wrong. Please refresh and try again. If the error persists, please contact Spark Support.'
